<mat-select
  class="lum-filter-multiselect-chips lum-select"
  [ngClass]="{ 'filter-multiselect': inlineChips }"
  [formControl]="optionForm"
  [placeholder]="placeholder"
  multiple
  (selectionChange)="onSelectionChange()"
>
  <mat-select-trigger>
    <mat-chip-list>
      <mat-chip
        *ngFor="let item of optionForm.value; trackBy: trackByValue"
        class="lum-chip"
        (removed)="remove(item)"
      >
        {{ item.label }}
        <button matChipRemove>
          <lum-ui-icon
            icon="close-circle"
            [width]="18"
            [height]="18"
            color="#000000"
          ></lum-ui-icon>
        </button>
      </mat-chip>
    </mat-chip-list>
  </mat-select-trigger>
  <mat-option *ngFor="let option of options" [value]="option">
    {{ option.label }}
  </mat-option>
</mat-select>
